module.exports = __webpack_public_path__ + "static/media/high-tech-square.1a6d0d3b.jpg";